<template>
  <div
    class="i-approximate-price"
    :class="additionalClass"
    v-if="showInformer"
  >
    <button
      @click="show = !show"
      :style="{width: iconWidth, height: iconHeight}"
    >
      <img :src="iconPath">
    </button>
    <div
      v-if="show && content"
      class="i-approximate-price__popup"
    >
      <button @click="show = false"><i class="fa fa-times"></i></button>
      {{ content }}
    </div>
  </div>
</template>
<script>
export default {
  name: "InformerApproximatePrice",
  props: {
    additionalClass: {
      type: String,
      required: false,
      default: "rt",
    },

    iconWidth: {
      type: String,
      required: false,
      default: "22px",
    },

    iconHeight: {
      type: String,
      required: false,
      default: "22px",
    },
  },
  data() {
    return {
      show: false,
      iconPath: "/images/icons/info-cena-cher.svg",
    };
  },
  mounted() {
    if (this.additionalClass === "rb") {
      this.iconPath = "/images/icons/info-cena-bel.svg";
    }
  },
  computed: {
    content() {
      return this.$store.state.settings.settings
        .informer_approximate_price_value;
    },
    showInformer() {
      return (
        this.$store.state.settings.settings.informer_approximate_price == "1"
      );
    },
  },
};
</script>
<style scoped>
.i-approximate-price {
  position: relative;
  display: grid;
  place-content: center;
}
.i-approximate-price__popup {
  position: absolute;
  right: 0;
  padding: 15px;
  font-size: 12px;
  background-color: #fbfbf9;
  border-radius: 3px;
  width: 300px;
  border: 1px #ccd1cb solid;
  color: #25271a;
  text-align: left;
  line-height: 1.2;
}
.i-approximate-price__popup button {
  position: absolute;
  top: 0px;
  right: 6px;
  color: #ccd1cb;
  font-size: 16px;
}
.rt .i-approximate-price__popup {
  top: 0;
  bottom: auto;
}
.rb .i-approximate-price__popup {
  top: auto;
  bottom: 0;
}

@media screen and (max-width: 550px) {
  .i-approximate-price__popup {
    position: fixed;
    width: 94%;
    right: 3%;
  }
  .rb .i-approximate-price__popup {
    top: auto;
    bottom: 2%;
  }
  .rt .i-approximate-price__popup {
    top: 2%;
  }
}
</style>

